import { render, staticRenderFns } from "./-ChangePassword.vue?vue&type=template&id=a8189496"
import script from "./-ChangePassword.vue?vue&type=script&lang=js"
export * from "./-ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports